<template>
  <div id="user_create">
      <TemplateLayout>
        <!-- Page Heading -->
        <h1 class="h3 mb-2 text-gray-800"> <router-link to="/user" class="text-gray-800">บัญชีผู้ใช้งาน</router-link> / <b class="text-primary">สร้างบัญชีผู้ใช้งานใหม่</b></h1>
        <p class="mb-4">ผู้ดูแลระบบสามารถสร้างบัญชีผู้ใช้งานให้กับเจ้าหน้าที่ในสำนักงาน สามารถแก้ไขข้อมูล เปลี่ยนแปลงสิทธิ์ และสามารถระงับการใช้งาน รวมถึงการเปลี่ยนรหัสผ่านแทนผู้ใช้งานได้</p>

        <!-- DataTales Example -->
        <form method="post" @submit.prevent="saveCreateUser">
            <div class="card shadow mb-4">
                <div class="card-header py-3">
                
                    <h6 class="m-0 font-weight-bold text-primary">ระบุข้อมูลผู้ใช้งาน</h6>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-lg-4 hide">
                            <label>คำนำหน้านาม</label>
                            <select v-model="title_id" class="form-control">
                                <option v-for="title in title_option" :key="title.title_id" :value="title.title_id">{{ title.title_name }}</option>
                            </select>
                        </div>
                        <div class="col-lg-8 hide"></div>
                        <div class="col-lg-4">
                            <label>ชื่อจริง</label>
                            <input required type="text" v-model="first_name" class="form-control"/>
                        </div>
                        <div class="col-lg-4">
                            <label>นามสกุล</label>
                            <input required type="text" v-model="last_name" class="form-control"/>
                        </div>
                        <div class="col-lg-4"></div>

                        <div class="col-lg-4">
                            <label>สิทธิ์การใช้งาน</label>
                            <router-link to="/privilege" class="float-right"><i class="fas fa-pen-alt fa-fw"></i>&nbsp;จัดการรายการ</router-link>
                            <select required v-model="privilege_id" class="form-control">
                                <option value="">กรุณาเลือก</option>
                                <option value="*">ผู้ดูแลระบบ (มองเห็นกล้องทั้งหมด)</option>
                                <option v-for="item in privilege_option" :key="item.privilege_id" :value="item.privilege_id">{{ item.privilege_name }}</option>
                            </select>
                        </div>

                        <div class="col-lg-4">
                            <label>ตำแหน่ง</label>
                            <router-link to="/position" class="float-right"><i class="fas fa-pen-alt fa-fw"></i>&nbsp;จัดการรายการ</router-link>
                            <select v-model="position_id" class="form-control">
                                <option value="">กรุณาเลือก</option>
                                <option v-for="item in position_option" :key="item.position_id" :value="item.position_id">{{ item.position_name }}</option>
                            </select>
                        </div>
                        
                        <div class="col-lg-4">
                            <label>แผนก</label>
                            <router-link to="/department" class="float-right"><i class="fas fa-pen-alt fa-fw"></i>&nbsp;จัดการรายการ</router-link>
                            <select v-model="department_id" class="form-control">
                                 <option value="">กรุณาเลือก</option>
                                <option v-for="item in department_option" :key="item.department_id" :value="item.department_id">{{ item.department_name }}</option>
                            </select>
                        </div>
                        <div class="col-lg-4">
                            <label>อีเมล์</label>
                            <input required type="email" v-model="email" class="form-control"/>
                        </div>
                        <div class="col-lg-4 hide">
                            <label>เบอร์โทร</label>
                            <input type="text" v-model="mobile" class="form-control"/>
                        </div>
                    </div>
                    <div class="alert alert-primary mt-3 mb-0">
                        <div class="row">
                            <div class="col-lg-4">
                                <label>เบอร์โทรศัพท์มือถือ 10 หลัก</label>
                                <input required maxlength="10" onkeypress="IsKeyNumber(event);"  type="text" v-model="username" placeholder="เบอร์โทร..." class="form-control"/>
                            </div>
                        </div>
                        <div class="mt-3">
                            <i class="text-danger fz-14">* กรุณากรอกเบอร์มือถือ 10 หลักของผู้ใช้งาน ที่ท่านต้องการสร้าง ระบบจะส่งคำเชิญผ่าน SMS ไปที่เบอร์ดังกล่าว โดยผู้ใช้จะต้องตอบรับผ่าน SMS เท่านั้น</i>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <button id="btnSaveData" type="submit" class="btn btn-primary">
                        <i class="fas fa-save fa-fw"></i>
                        บันทึกข้อมูล
                    </button>
                </div>
            </div>
        </form>
      </TemplateLayout>
  </div>
</template>

<script>

import TemplateLayout from "@/components/layout/TemplateLayout.vue";
import { MasterService } from '@/services/master.service';
import { UsersService } from '@/services/users.service';
import { AlertService } from '@/services/alert.service';

export default {
  name: 'UserCreated',
  components: {
    TemplateLayout
  },
  data() {
      return {
        title_option: [],
        privilege_option: [],
        position_option: [],
        department_option: [],
        title_id: "",
        first_name: "",
        last_name: "",
        privilege_id: "",
        position_id: "",
        department_id: "",
        email: "",
        mobile: "",
        username: "",
        password: "",
        password_confirm: ""
      }
  },
  methods: {
      async bindSelectOption ()
      {
        this.title_option = await MasterService.getMasterList("title");
        this.privilege_option = await MasterService.getMasterList("privilege");
        this.position_option = await MasterService.getMasterList("position");
        this.department_option = await MasterService.getMasterList("department");
      },
      async saveCreateUser()
      {
        if(AlertService.confirm(window.$("#btnSaveData"),"ยืนยันรายการ?")){
        AlertService.loading(true,"บันทึกรายการ");
        this.mobile = this.username;
        this.password = this.username;
        this.password_confirm = this.username;
        var data = {
            first_name: this.first_name,
            last_name: this.last_name,
            mobile: this.mobile,
            email: this.email,
            title_id: this.title_id,
            position: this.position_id,
            department: this.department_id,
            privilege: this.privilege_id,
            username: this.username,
            password: this.password,
            password_confirm: this.password_confirm
        };
        const respons = await UsersService.userCreate(data);
        if(respons.status == 200){
            AlertService.success("บันทึกสำเร็จ");
            setTimeout(() => {
                this.$router.push({ path: `user_detail/${respons.data.user_id}` })
            }, 200);
        }else{
            AlertService.error("ทำรายการไม่สำเร็จ",respons.message)
        }
        AlertService.loading(false);
        }
        return false;
      }
  },    
  mounted() {
    this.bindSelectOption();
  },
}

</script>

<style>

</style>